import {Button, Divider, Stack, Typography, useTheme} from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import React, {Fragment} from 'react';

import {CopySection} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {formatText, getAddressforMaps} from 'presentation/utils';

import {OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';
import {Drawer} from 'presentation/components/Drawer';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';
import {UnitDetailsDrawerProps} from './types';

const {unitDetails, attendanceUnit, phones} = translations['pt-br'].commons;

const {seeMap, copiedPhone} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export function UnitDetailsDrawer({
	onOpen,
	onClose,
	open,
	phoneNumbers,
	address,
	unitName,
	specialtyName,
}: UnitDetailsDrawerProps) {
	const theme = useTheme();

	const addressFormated = getAddressforMaps(address);

	const handleOpenGoogleMaps = () => openGoogleMaps(addressFormated?.addressForMaps || '');
	const isPhoneNumberEmpty = phoneNumbers?.length === 0;

	return (
		<Drawer.Root
			open={open}
			onClose={onClose}
			onOpen={onOpen}
			width={'600px'}
			customMaxHeight={85}
			sx={{zIndex: 9000}}>
			<Drawer.Header onClose={onClose} title={unitDetails} />
			<Drawer.Content>
				<Stack mt={1} gap={0.5}>
					<Typography variant="subtitle2" fontSize={20} color={'primary'}>
						{formatText(unitName)}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{specialtyName}
					</Typography>
				</Stack>
				<Divider sx={{my: 2}} />
				{isPhoneNumberEmpty ? null : (
					<Fragment>
						<Stack gap={1.5}>
							<Typography variant="subtitle2" color="text.secondary">
								{phones}
							</Typography>
							<Grid2 container spacing={2}>
								{phoneNumbers?.map(phone => (
									<Grid2 size={{xs: 12, sm: 12, md: 6}} key={phone}>
										<CopySection
											value={phone}
											highlightedIcons
											callAction
											snackbarMessage={copiedPhone}
										/>
									</Grid2>
								))}
							</Grid2>
						</Stack>
						<Divider sx={{my: 2}} />
					</Fragment>
				)}
				<Stack gap={1.5}>
					<Typography variant="subtitle2" color="text.secondary">
						{attendanceUnit}
					</Typography>
					<Stack direction="row" gap={1} alignItems={'center'}>
						<Stack minWidth={20}>
							<Icon
								name={'location-on-filled'}
								size={20}
								color={theme.palette.primary.main}
							/>
						</Stack>
						<Typography variant="body2" color="text.secondary">
							{address}
						</Typography>
					</Stack>

					<Button
						variant="outlined"
						fullWidth
						onClick={handleOpenGoogleMaps}
						data-tag-id={OdontoBookingTaggingEnum.CLICK_VER_MAPA_DRAWER_REDE_CRED}>
						{seeMap}
					</Button>
				</Stack>
			</Drawer.Content>
		</Drawer.Root>
	);
}
